import React from 'react';
import { Stack } from '@chakra-ui/react';

type PropTypes = {
  children: React.ReactNode,
};

const FlippyStack = ({ children }: PropTypes) => (
  <Stack direction={{ base: 'column', md: 'row' }}>{children}</Stack>
)

export default FlippyStack;
